import '@pinflag/pinflag-ui-kit/styles'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { DataProvider } from './context/DataContext'
import ErrorBoundary from './ErrorBoundary'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <DataProvider>
        <App />
      </DataProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
